export default {
    PRIMEIRA_CONSULTA: 1,
    CONSULTA_RETORNO: 2,
    CONSULTA_MANUTENCAO: 3,
    VISITA_DOMICILIAR_POS_OBITO: 8,
}